import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { CustomerStoreOrdersPaper } from '../CustomerManagement/components/CustomerStoreOrdersPaper/CustomerStoreOrdersPaper';
import { StoreCustomerPermissionsPanel } from './StoreCustomerPermissionsPanel';
import { StoreCustomerShell, useStoreCustomerShell } from './StoreCustomerShell';
import {
    STORE_CUSTOMER_ACTIVE_TAB_ORDERS,
    STORE_CUSTOMER_ACTIVE_TAB_MANAGEMENT,
} from './storeCustomerTabs.constants';

const StoreCustomerOrdersContent: FC = () => {
    const { memberDatas } = useStoreCustomerShell();
    if (!memberDatas?.customer) {
        return null;
    }
    return <CustomerStoreOrdersPaper datas={memberDatas} receiptDisplayMode="preview" />;
};

const StoreCustomerTabContent: FC = () => {
    const location = useLocation();
    const activeTab = new URLSearchParams(location.search).get('ActiveTab') ?? STORE_CUSTOMER_ACTIVE_TAB_MANAGEMENT;

    if (activeTab === STORE_CUSTOMER_ACTIVE_TAB_ORDERS) {
        return <StoreCustomerOrdersContent />;
    }
    return <StoreCustomerPermissionsPanel />;
};

export const StoreCustomerManagement: FC = () => (
    <StoreCustomerShell>
        <StoreCustomerTabContent />
    </StoreCustomerShell>
);
